export default () => ({
  handler: 'relativeUrl',
  data: ({ quickDepositLink } = {}) => {
    if (quickDepositLink !== undefined) {
      return quickDepositLink;
    }
    return '/quick_deposit';
  },
});
